import { Tooltip, Typography } from "@mui/material"
import { NOT_SAVED_ID } from "app/model"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IListIdCellProps {
  label: string
  id: number | string
  description?: string | null
  cellId?: string | number // used to generate dom id for tests
  onClick?: () => any
}

export const ListIdCell = React.memo(({ label, description, id, cellId, onClick }: IListIdCellProps) => (
  <FlexBox vertical ai="start" sx={{ maxWidth: "100%" }}>
    <Tooltip title={label ? (description ? `${label} - ${description}` : label) : description || ""}>
      <Typography
        id={cellId !== undefined ? `${cellId}-text` : undefined}
        onClick={onClick ? () => onClick() : undefined}
        sx={{
          "maxWidth": "100%",
          "fontSize": ".8rem",
          "fontWeight": 300,
          "cursor": onClick ? "pointer" : undefined,
          "overflow": "hidden",
          "textOverflow": "ellipsis",
          "whiteSpace": "nowrap",
          "&:hover": {
            fontWeight: onClick ? "600" : undefined
          }
        }}
        color="textPrimary">
        {label}
      </Typography>
    </Tooltip>
    {id !== NOT_SAVED_ID && (
      <Typography
        id={cellId !== undefined ? `${cellId}-id` : undefined}
        sx={{
          fontSize: ".6rem",
          fontWeight: 400
        }}
        color="textSecondary">
        ID: {id}
      </Typography>
    )}
  </FlexBox>
))
